import { useNavigate } from 'react-router';
import { Box, Button, Container, Paper, Typography } from '@mui/material';

import { Link } from '@barboxx/admin-components';

export default function RestrictedPage() {
    const navigate = useNavigate();
    const goBack = () => navigate(-1);

    return (
        <Container
            maxWidth="md"
            sx={{
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                display: 'flex',
            }}
        >
            <Paper
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column',
                    padding: 5,
                }}
            >
                <Typography padding={5} variant="h2">
                    Restricted Access Only
                </Typography>
                <Box>
                    <Link to="/">Return Home</Link>
                </Box>
                <Button onClick={goBack}>Go Back</Button>
            </Paper>
        </Container>
    );
}
